// IE Hub - Welcome Hero Component
// Reusable welcome/hero section used across dashboard and completion screens

import { Box, Button, Typography } from '../ui';
import TaglineText from './TaglineText';

interface WelcomeHeroProps {
  userName?: string;
  onContinue: () => void;
  buttonText?: string;
}

export default function WelcomeHero({ 
  userName = "User", 
  onContinue,
  buttonText = "Get Started →"
}: WelcomeHeroProps): JSX.Element {
  return (
    <Box sx={{ 
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      px: { xs: 3, md: 2 },
      py: 4
    }}>
      {/* IE Hub Logo */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        mb: { xs: 6, md: 6 }
      }}>
        <Box 
          component="img"
          src="/assets/icons/yellowIcon.png"
          alt="IE Hub"
          sx={{
            width: { xs: 120, md: 180 },
            height: { xs: 60, md: 92.78 },
            borderRadius: 2,
            mr: { xs: 2, md: 0 }
          }}
        />
   
      </Box>

      {/* Welcome Message */}
      <Typography 
        variant="h4" 
        sx={{ 
          fontWeight: 600, 
          mb: 3,
          color: 'white',
          fontSize: { xs: '1.5rem', sm: '2rem', md: '2rem' }
        }}
      >
        Hi {userName}, Welcome to IE Hub
      </Typography>

      {/* Tagline */}
      <TaglineText 
        variant="h6"
        sx={{ 
          mb: 6,
          maxWidth: { xs: '400px', md: '600px' },
          fontSize: { xs: '1rem', sm: '1.25rem', md: '1.25rem' },
          color: { xs: 'white', md: 'white' },
          opacity: 0.9
        }}
      />

    </Box>
  );
}
